import { createSelector } from 'reselect';

// Create select function to pick off the pieces of state we care about for this calculation
const getProfileSelector = (state) => state.profile;

export const getProfile = createSelector(getProfileSelector,  //pick off a piece of state
	(profile) => profile // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
);


// WEBPACK FOOTER //
// ./src/features/profile/selector.js